import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10002;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(174, 174, 174, 0.7);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 29px;
`;

export const LoadingImage = styled.img`
  width: 241px;
  height: 241px;
`;

export const Message = styled.p`
  margin: 0;
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  text-align: center;
`;
